import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'ms-MY'],

  // Used when no locale matches
  defaultLocale: 'ms-MY',
})
